export default "__VITE_ASSET__Jc5ZOa6t__"